import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {DomSanitizer} from "@angular/platform-browser";
import {SupportService} from "../../service/support/support.service";
import {NavigationService} from "../../service/navigation.service";

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  frameUrl;
  constructor(private loaderService: LoaderService,
              public sanitizer: DomSanitizer,
              private supportService: SupportService,
              private navigationService: NavigationService,
              private popupComponent: PopupComponent) {

  }

  ngOnInit() {
    this.getChatLink();
    this.scrollToTop();
  }

  scrollToTop() {
    const element = document.getElementById('settingsHeader');
    let elementPosition = element ? element.offsetTop : 0;
    document.querySelector('.main__inner').scrollTo({
      top: elementPosition - 10, //add your necessary value
      behavior: "smooth"  //Smooth transition to roll
    });
  }

  getChatLink() {
    // let djd = {session: "03cd76967c804947b206757249d068e3",
    //     sessionLink: "https://chat.dev.eboxenterprises.com/auth/03cd76967c804947b206757249d068e3",
    //     status: true};
    // this.getChatLinkResult(djd);
    this.supportService.getSession().subscribe(data => {
      this.getChatLinkResult(data);
    }, (error) => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      this.loaderService.hide();
    });
  }

  getChatLinkResult(data) {
    try {
      if (data.status) {
        this.frameUrl = this.getLink(data.sessionLink);
      } else if (data.status === false) {
        this.popupComponent.showPopupError({text: data.message});
      } else {
        this.loaderService.hideAndShowTryAgain();
      }
    } catch (e) {
      this.loaderService.hideAndShowTryAgain();
    }

  }

  getLink(url){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  goBack() {
    this.navigationService.goToHomePage();
  }
}
